import * as React from "react";
import { Box, Tabs as RadixTabs } from "@radix-ui/themes";

export function Tabs(props) {

    const [value, setValue] = React.useState(props.activeTab ? props.activeTab : props.children[0].props["data-label"]);

    React.useEffect(() => {
        setValue(props.activeTab ? props.activeTab : props.children[0].props["data-label"]);
    }, [props.children]);

    return <RadixTabs.Root onValueChange={(e) => {
        if (props.onValueChange) {
            props.onValueChange(e);
        }
        setValue(e);
    }} defaultValue={props.children[0].props["data-label"]} value={value}>
        <RadixTabs.List>
            {
                props.children.map((child, index) => {
                    if (child.props && child.props["data-label"]) {
                        return <RadixTabs.Trigger key={index + "tab"} value={child.props["data-label"]}>{child.props["data-label"].charAt(0).toUpperCase() + child.props["data-label"].slice(1)}</RadixTabs.Trigger>;
                    }
                })
            }
        </RadixTabs.List>
  
        <Box>
            {
                props.children.map((child, index) => {
                    if (child.props && child.props["data-label"]) {
                        return  <RadixTabs.Content key={index} value={child.props["data-label"]}>
                            {child}
                        </RadixTabs.Content>;
                    }
                })
            }
        </Box>
    </RadixTabs.Root>;
}